import { setApiError } from '../redux/slices/apiStatusSlice';
import i18n from '../i18n';

export const handleApiError = (error, apiKey, dispatch, fallbackKey = 'errors.general') => {
  let errorMessage;

  if (error?.response?.data?.errorMessage) {
    const apiErrorMessage = error.response.data.errorMessage;
    // API error mesajını çevirmeye çalış
    const translatedApiError = i18n.t(`errors.api_errors.${apiErrorMessage}`, { defaultValue: apiErrorMessage });
    errorMessage = translatedApiError;
  } else if (error?.message) {
    // Önce direkt error.message'ı çevirmeye çalış (signup.error.certificates-validation-failed gibi)
    const directTranslation = i18n.t(error.message, { defaultValue: null });
    if (directTranslation !== null && directTranslation !== error.message) {
      errorMessage = directTranslation;
    } else {
      // Sonra api_errors altında ara
      const translatedError = i18n.t(`errors.api_errors.${error.message}`, { defaultValue: error.message });
      errorMessage = translatedError;
    }
  } else {
    errorMessage = i18n.t(fallbackKey);
  }

  dispatch(
    setApiError({
      key: apiKey,
      error: errorMessage,
    }),
  );

  return errorMessage;
};

export const handleError = (error, fallbackKey = 'errors.general') => {
  if (error?.response?.data?.errorMessage) {
    return error.response.data.errorMessage;
  } else if (error?.message) {
    return error.message;
  } else {
    return i18n.t(fallbackKey);
  }
};
